export default {
  sections: {
    business_info: 'Virksomhedsoplysninger',
    bank_info: 'Bankoplysninger',
  },
  form: {
    company_name: {
      label: 'Restaurantens navn',
      placeholder: 'Restaurantens navn',
    },
    business_name: {
      label: 'Virksomhedens navn',
      placeholder: 'Virksomhedens navn',
    },
    owner_full_name: {
      label: 'Ejerens navn',
      placeholder: 'Ejerens navn',
    },
    business_address: {
      label: 'Virksomhedens adresse',
      placeholder: 'Virksomhedens adresse',
    },
    business_zip_code: {
      label: 'Virksomhedens postnummer',
      placeholder: 'Virksomhedens postnummer',
    },
    business_city: {
      label: 'Virksomhedens by',
      placeholder: 'Virksomhedens by',
    },
    business_country: {
      label: 'Virksomhedens land',
      options: {
        DE: 'Tyskland',
        GB: 'Storbritannien',
        US: 'USA',
      },
    },
    company_phone_number: {
      label: 'Restaurantens telefonnummer',
      placeholder: 'Restaurantens telefonnummer',
    },
    contact_person_full_name: {
      label: 'Kontaktpersonens navn',
      placeholder: 'Kontaktpersonens navn',
    },
    contact_person_phone_number: {
      label: 'Kontaktpersonens telefonnummer',
      placeholder: 'Kontaktpersonens telefonnummer',
    },
    contact_person_email: {
      label: 'Kontaktpersonens e-mail',
      placeholder: 'Kontaktpersonens e-mail',
    },
    business_bank_account_holder_name: {
      label: 'Kontoindehaverens navn',
      placeholder: 'Kontoindehaverens navn',
    },
    business_bank_account_number: {
      label: 'Kontonummer',
      placeholder: 'DE01101234567891234567',
    },
    business_bank_routing_number: {
      label: 'Registreringsnummer',
      placeholder: '110000000',
    },
    business_tax_id: {
      label: 'Virksomhedens CVR-nummer',
      placeholder: 'Virksomhedens CVR-nummer',
    },
  },
};
